var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 77.146,
    height: 88.775,
    viewBox: "0 0 77.146 88.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_5977",
    x: 0,
    y: 0,
    width: 77.146,
    height: 76.14,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.243
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3912",
    "data-name": "Group 3912",
    transform: "translate(-125.533 -117.97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3703",
    "data-name": "Group 3703",
    transform: "translate(133.676 126.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8.14, -8.03)",
    filter: "url(#Path_5977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5977-2",
    "data-name": "Path 5977",
    d: "M18.609,0,17.89,7.3l-.459,6.123-.952,11.5L9.15,24.326,0,23.4l.284,1.244,1.443,1.98L5.4,30.555l1.4.937L7.97,34.161l-.007,1.667.514,1.35,1.753,1.776,1.643.834L14.2,41.5l2.078-1.279L17.4,37.549l1.846-.645L23.5,37.939l3.3,3.7,1.752,4.766,1.57,1.623.385,1.055,1.377.958.532,2.52,1.444,4.068,4.5,2.152,2.009.047,1.846,1.206,1.4-.7-1.081-5.978.436-2.009,2.047-3.293L48.4,45.485l3.934-2.014L56.1,40.114l2.563-1.167,1.045-.13-.451-.611L60.3,36.794l-.186-2.708L61,31.963l-.057-1.444-1.46-2.184-1.015-2.23-.123-5.7-.063-2.956-2.028-.443-1.63-.542-1.763-1.219-4.2.736-.965.763-2.671-1.41-2.245.643-1.019-.948-.9.773L39.83,14.367l-2.887-.222-2.033-.527-.355-.971-1.9-.039-1.33-1.053L31.776.769,24.652.409Z",
    transform: "translate(8.14 8.03)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTx);
export default __webpack_public_path__ + "static/media/TX.9f498d7ae6074200f3f379c89bbec563.svg";
export { ForwardRef as ReactComponent };